const chatBody = document.getElementById('talkMain')

//   ####   ####  #####     #####   ##      ##
//  ##     ##     ##  ##   ##   ##  ##      ##
//   ###   ##     #####    ##   ##  ##      ##
//     ##  ##     ##  ##   ##   ##  ##      ##
//  ####    ####  ##   ##   #####   ######  ######

//            ##   ##  ##     ##  #####    #####    ###    ####
//            ##   ##  ####   ##  ##  ##   ##      ## ##   ##  ##
//  ########  ##   ##  ##  ## ##  #####    #####  ##   ##  ##  ##
//            ##   ##  ##    ###  ##  ##   ##     #######  ##  ##
//             #####   ##     ##  ##   ##  #####  ##   ##  ####

// 未読にスクロールさせる

function scrollUnread() {
  const unreadLine = document.getElementById('talkEnd')
  if (!chatBody || !unreadLine) {
    return
  }
  chatBody.scrollTop = unreadLine.offsetTop
}
scrollUnread()

//  #####  ##  ##      #####            ##   ##  ##
//  ##     ##  ##      ##               ##   ##  ##
//  #####  ##  ##      #####  ########  ##   ##  ##
//  ##     ##  ##      ##               ##   ##  ##
//  ##     ##  ######  #####             #####   ##
/*
<div class="customFile flex vcenter">
    <label class="customFile__frame flex vcenter">
        <input id="js-customFile--entry" class="js-customFile customFile__input" data-target="entry" type="file" name="entry_file" />
        <div class="customFile__btn flex vcenter hcenter">ファイル選択</div>
        <div class="js-customFile-out--entry customFile__text" data-def="5MB以内のPDFファイルをアップロードしてください。">
            5MB以内のPDFファイルをアップロードしてください。
        </div>
    </label>
    <button type="button" class="js-customFile-toggle--entry js-customFile-del customFile__del" data-target="entry">×クリア</button>
</div>
<input id="js-customFile-name--entry" type="text" class="js-customFile-trace is-none" name="doc" data-target="entry">
*/
// ファイルアップロードUIのカスタム
const customFileUpload = document.getElementsByClassName('js-customFile')
const customFileNameTrace = document.getElementsByClassName('js-customFile-trace')
const customFileReader = new FileReader()

if (customFileUpload[0]) {
  window.addEventListener('change', function (e) {
    fileUpSet(e.target)
  })
  window.addEventListener('click', function (e) {
    fileUpDel(e.target)
  })
}

function fileUpSet(item) {
  if (!item.classList.contains('js-customFile')) {
    return
  }

  const file = item.files[0] // ファイルを取得
  const target = item.dataset.target // 各種反映先のスラッグ

  const fileSizeLimit = 1 // サイズ上限（MB）
  const sizeUnit = file.size > 1024 * 1024 ? 'MB' : 'KB' // 単位をMBかKBに分岐
  const fileSizeUnit = sizeUnit === 'MB' ? file.size / (1024 * 1024) : file.size / 1024 // 単位に合わせて補正したファイルサイズ
  const fileSizeView = fileSizeUnit.toFixed(2) + sizeUnit // ファイルサイズ出力テキスト

  // 表示するテキスト
  let fileText = file.name + ' (' + fileSizeView + ')'
  // エラー判定
  let isError = false

  // サイズバリデーション
  if (file.size > fileSizeLimit * (1024 * 1024)) {
    isError = true
    item.value = '' // 入力を削除
    fileText = `<span style="color:red">ファイルサイズは${fileSizeLimit}MB以下にしてください (${fileSizeView})。</span>`
  }
  // 拡張子バリデーション　実際の中身ではなく、ファイル名だけを見る簡単なもの
  if (!checkExt(file.name, ['jpg', 'jpeg', 'png', 'gif', 'webp'])) {
    isError = true
    item.value = '' // 入力を削除
    fileText = '<span style="color:red">画像ファイルのみがアップロードできます。</span>'
  }

  // ファイル名やエラーを表示させる
  const fileTextTarget = document.getElementsByClassName('js-customFile-out--' + target)
  for (let index = 0; index < fileTextTarget.length; index++) {
    fileTextTarget[index].innerHTML = fileText
  }

  // ファイル名を送信させる
  const fineNameTarget = document.getElementById('js-customFile-name--' + target)
  if (fineNameTarget) {
    if (!isError) {
      fineNameTarget.value = file.name
    } else {
      fineNameTarget.value = ''
    }
  }

  customFileReader.readAsDataURL(file)
  customFileReader.onload = function (event) {
    let isReadFile = false
    // BASE64版のデータをセットする
    const fineBase64Target = document.getElementsByClassName('js-customFile-base64--' + target)
    if (fineBase64Target[0]) {
      if (!isError) {
        for (const iterator of fineBase64Target) {
          iterator.value = customFileReader.result
        }
        isReadFile = true
      } else {
        for (const iterator of fineBase64Target) {
          iterator.value = ''
        }
      }
    }

    // 画像ファイルをプレビューさせる
    const finePreviewTarget = document.getElementsByClassName('js-customFile-preview--' + target)
    if (finePreviewTarget[0]) {
      if (!isError) {
        for (const iterator of finePreviewTarget) {
          iterator.innerHTML = '<img src="' + customFileReader.result + '">'
        }
        isReadFile = true
      } else {
        for (const iterator of finePreviewTarget) {
          iterator.innerHTML = ''
        }
      }
    }
  }

  // 切り替わる要素を反映させる
  const fineDelTarget = document.getElementsByClassName('js-customFile-toggle--' + target)
  if (fineDelTarget[0]) {
    if (!isError) {
      for (const iterator of fineDelTarget) {
        iterator.classList.add('active')
      }
    } else {
      for (const iterator of fineDelTarget) {
        iterator.classList.remove('active')
      }
    }
  }

  // 文字列から拡張子を返す
  function getExt(fileName) {
    const pos = fileName.lastIndexOf('.')
    if (pos === -1) return ''
    return fileName.slice(pos + 1)
  }
  // 拡張子を検証する
  function checkExt(fileName, exts) {
    // 比較のため小文字にする
    const ext = getExt(fileName).toLowerCase()
    // 許可する拡張子の一覧extsから対象の拡張子があるか確認する
    if (exts.indexOf(ext) === -1) {
      return false
    }
    return true
  }
}
function fileUpDel(item) {
  if (!item.classList.contains('js-customFile-del')) {
    return
  }

  const target = item.dataset.target // 各種反映先のスラッグ

  // ファイルを消す
  document.getElementById('js-customFile--' + target).value = ''

  // 送信するファイル名を消す
  const fineNameTarget = document.getElementById('js-customFile-name--' + target)
  if (fineNameTarget) {
    fineNameTarget.value = ''
  }

  // BASE64版のデータを消す
  const fineBase64Target = document.getElementsByClassName('js-customFile-base64--' + target)
  if (fineBase64Target[0]) {
    for (const iterator of fineBase64Target) {
      iterator.value = ''
    }
  }

  // 切り替わる要素を消す
  const fineDelTarget = document.getElementsByClassName('js-customFile-toggle--' + target)
  if (fineDelTarget[0]) {
    for (const iterator of fineDelTarget) {
      iterator.classList.remove('active')
    }
  }

  // テキスト表示欄をリセットする
  const fileTextTarget = document.getElementsByClassName('js-customFile-out--' + target)
  for (let index = 0; index < fileTextTarget.length; index++) {
    fileTextTarget[index].innerHTML = fileTextTarget[index].dataset.def
  }
}

//    ###        ##    ###    ##    ##
//   ## ##       ##   ## ##    ##  ##
//  ##   ##      ##  ##   ##    ####
//  #######  ##  ##  #######   ##  ##
//  ##   ##   ####   ##   ##  ##    ##

const dmPost = document.getElementById('dmPost')
const dmPostLoad = document.getElementById('dmPostLoad')

if (dmPost) {
  chatAjax()
}

function chatAjax() {
  let ajax = false // Ajaxリクエスト
  let ajaxResponse = '' // 最後のレスポンスを格納する

  /*
         ########  #######  ########  ##     ##
         ##       ##     ## ##     ## ###   ###
         ##       ##     ## ##     ## #### ####
 ####### ######   ##     ## ########  ## ### ##
         ##       ##     ## ##   ##   ##     ##
         ##       ##     ## ##    ##  ##     ##
         ##        #######  ##     ## ##     ##

フォーム送信して結果を反映する

<form action="hoge.php" method="POST" name="form-name">
  <button type="button" class="js-chatSubmit" data-form="form-name" data-input="type,item" data-require="" >
      更新
  </button>
</form>

*/

  if (document.getElementsByClassName('js-chatSubmit')[0]) {
    window.addEventListener('click', (e) => {
      if (e.target.classList.contains('js-chatSubmit') && e.target.tagName === 'BUTTON') {
        e.preventDefault()
        chatSubmit(e.target)
      }
    })
  }
  if (document.getElementsByClassName('js-chatSubmit')[0]) {
    window.addEventListener('change', (e) => {
      if (e.target.classList.contains('js-chatSubmit')) {
        e.preventDefault()
        chatSubmit(e.target)
      }
    })
  }

  function chatSubmit(item) {
    let param = '' // 送信パラメータ
    const name = item.dataset.form
    const form = document.forms[name] // 指定nameのformに存在するinputにアクセス
    const url = form.action // 取得先
    const method = form.method // GET/POST

    const type = item.dataset.type // add(追加)もしくはrep(差し替え)
    const from = item.dataset.from // 取得要素
    const to = item.dataset.to // 差し替え要素
    const pushSt = item.dataset.push // URLのプッシュ
    const scroll = item.dataset.scroll // スクロール先

    // 指定されているinputを取得して送信データ化する
    const inputList = item.dataset.input.split(',') // ,区切りで配列に変換

    let isEmpty = true
    for (let index = 0; index < inputList.length; index++) {
      if (index !== 0) {
        param += '&'
      }
      const input = inputList[index]
      const valueList = document.querySelectorAll('form[name="' + name + '"] [name="' + input + '"]')
      let value = ''

      for (const valueItem of valueList) {
        if ((valueItem.type === 'checkbox' || valueItem.type === 'radio') && !valueItem.checked) {
          continue
        }
        if (value !== '') {
          value += ',' // 配列系のデータはカンマ区切りにする
        }
        value += valueItem.value
      }

      param += input + '=' + encodeURIComponent(value)
      if (isEmpty && value !== '' && (input === 'file_base64' || input === 'text')) {
        isEmpty = false
      }
    }

    if (!isEmpty) {
      applyAjax(url, method, param, from, to, pushSt, type, scroll)
    } else {
      window.popToast('メッセージや画像ファイルを入力してください')
    }
  }

  /*
           ###    ########  ########  ##       ##    ##
         ##   ##  ##     ## ##     ## ##         ####
####### ##     ## ########  ########  ##          ##
        ######### ##        ##        ##          ##
        ##     ## ##        ##        ########    ##
*/
  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
   * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
   * @param scroll {string} 指定の位置にスクロールさせる
   * @param flag {string} 独自の拡張用
   */
  function applyAjax(url, method = 'get', param, from, to, pushSt, type = 'rep', scroll = false, flag = null) {
    // from = from.split(',') // ,区切りで配列に変換
    // to = to.split(',') // ,区切りで配列に変換

    // ローディング処理
    dmPostLoad.classList.add('active')

    if (ajax) {
      // 既に通信中なら切断
      ajax.abort()
    }

    ajax = new XMLHttpRequest() // Ajaxリクエスト
    if (method === 'post') {
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    } else {
      if (param) {
        url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
      }
      if (pushSt === 'on') {
        history.pushState(null, null, url) // URL変更
      }
      // Ajaxと明示するパラメータを付ける
      url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    }
    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
    if (method === 'post') {
      ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
    }
    ajax.responseType = 'document' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間
    if (method === 'post') {
      ajax.send(param) // POSTリクエスト実行
    } else {
      ajax.send() // GETリクエスト実行
    }
    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー

        window.popToast('送信に失敗しました。時間をおいてやり直してください。')
        dmPostLoad.classList.remove('active')
        return
      }

      // セットされているファイルを消す
      const fileUp = document.getElementById('js-customFile-del--file')
      fileUpDel(fileUp)

      // メッセージを空にする
      document.getElementById('dmPostText').value = ''

      dmPostLoad.classList.remove('active')

      if (flag !== 'reload') {
        chatReload()
      }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      // intObsAjax()
      ajax = false
    }
  }

  //  #####    #####  ##       #####     ###    ####
  //  ##  ##   ##     ##      ##   ##   ## ##   ##  ##
  //  #####    #####  ##      ##   ##  ##   ##  ##  ##
  //  ##  ##   ##     ##      ##   ##  #######  ##  ##
  //  ##   ##  #####  ######   #####   ##   ##  ####

  let reloadAjax

  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (e.target.classList.contains('js-dmReload')) {
      applyReloadAjax(location.href, 'get', '', '#dmTalkArea', '#dmTalkArea', false, 'rep', false, 'anime') // チャット欄リロード
    }
  })

  function chatReload() {
    applyReloadAjax(location.href, 'get', '', '#dmTalkArea', '#dmTalkArea', false, 'rep', false, null) // チャット欄リロード
  }
  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
   * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
   * @param scroll {string} 指定の位置にスクロールさせる
   * @param flag {string} 独自の拡張用
   */
  function applyReloadAjax(url, method = 'get', param, from, to, pushSt, type = 'rep', scroll = false, flag = null) {
    from = from.split(',') // ,区切りで配列に変換
    to = to.split(',') // ,区切りで配列に変換

    const loadingItem = document.createElement('div')
    loadingItem.className = 'md-loading active'

    if (reloadAjax) {
      // 既に通信中なら切断
      reloadAjax.abort()
    }

    if (flag === 'anime') {
      // ローディング処理
      for (let index = 0; index < to.length; index++) {
        const itemTo = document.querySelector(to[index])
        const loadingItem = document.createElement('div')
        loadingItem.className = 'md-loading md-loading--full active'
        if (type === 'rep') {
          loadingItem.style.width = itemTo.offsetWidth + 'px'
          loadingItem.style.height = itemTo.offsetHeight + 'px'
          itemTo.innerHTML = ''
        }
        itemTo.appendChild(loadingItem)
      }
    }

    reloadAjax = new XMLHttpRequest() // Ajaxリクエスト
    if (method === 'post') {
      reloadAjax.open(method, url, true) // GET/POST, URL, 非同期処理
    } else {
      if (param) {
        url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
      }
      if (pushSt === 'on') {
        history.pushState(null, null, url) // URL変更
      }
      // Ajaxと明示するパラメータを付ける
      url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
      reloadAjax.open(method, url, true) // GET/POST, URL, 非同期処理
    }
    // ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
    if (method === 'post') {
      reloadAjax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
    }
    reloadAjax.responseType = 'document' // 取得タイプ document text json
    reloadAjax.timeout = 10000 // タイムアウト判定時間
    if (method === 'post') {
      reloadAjax.send(param) // POSTリクエスト実行
    } else {
      reloadAjax.send() // GETリクエスト実行
    }
    reloadAjax.onload = function () {
      // アクセス成功
      if (reloadAjax.status < 200 || reloadAjax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
        return
      }

      if (reloadAjax.response === ajaxResponse) {
        // 前と結果が同じなら何もしない
        return
      }
      ajaxResponse = reloadAjax.response // 取得結果を更新

      let ajaxData = ajaxResponse // 実際に使用するデータ

      // // IEは取得タイプJSONをtextで受け取るのでJSONにパースする
      // if (navigator.userAgent.indexOf('Trident') !== -1 && JSON) {
      //   ajaxData = JSON.parse(ajaxData)
      // }
      for (let index = 0; index < to.length; index++) {
        const itemFrom = ajaxData.querySelector(from[index])
        const itemTo = document.querySelector(to[index])

        itemTo.innerHTML = itemFrom.innerHTML
      }

      document.getElementById('dmTalkArea').scrollIntoView({
        behavior: 'instant',
        block: 'end',
        inline: 'nearest',
      })
    }
    reloadAjax.ontimeout = function (e) {
      // タイムアウト
    }
    reloadAjax.onerror = function () {
      // Ajax処理失敗
    }
    reloadAjax.onloadend = function () {
      // 受信成否に関わらず実行
      // intObsAjax()
      reloadAjax = false
    }
  }
}

//  ###    ###   #####   ####      ###    ##
//  ## #  # ##  ##   ##  ##  ##   ## ##   ##
//  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
//  ##      ##  ##   ##  ##  ##  #######  ##
//  ##      ##   #####   ####    ##   ##  ######
if (document.getElementsByClassName('js-chatModal-open')[0]) {
  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (!e.target.classList.contains('js-chatModal-open')) {
      return
    }

    const talkID = e.target.dataset.talkId
    const talkType = e.target.dataset.talkType

    // 使用するフォームにトークIDをセットする
    const idTargetList = document.getElementsByClassName('js-chatModal-id--' + talkType)
    for (const iterator of idTargetList) {
      iterator.value = talkID
      iterator.dataset.talkId = talkID
    }

    // メニュー展開状態をリセット
    const mainMenuList = document.getElementsByClassName('js-talkModal-main')
    for (const iterator of mainMenuList) {
      iterator.classList.add('active')
    }
    const subMenuList = document.getElementsByClassName('js-talkModal-sub')
    for (const iterator of subMenuList) {
      iterator.classList.remove('active')
    }
  })
}
//  ###    ###  #####  ##     ##  ##   ##
//  ## #  # ##  ##     ####   ##  ##   ##
//  ##  ##  ##  #####  ##  ## ##  ##   ##
//  ##      ##  ##     ##    ###  ##   ##
//  ##      ##  #####  ##     ##   #####
if (document.getElementsByClassName('js-talkMenu')[0]) {
  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (!e.target.classList.contains('js-talkMenu')) {
      return
    }

    const type = e.target.dataset.type

    const menuMainList = document.getElementsByClassName('js-talkMenu--main')
    for (const iterator of menuMainList) {
      iterator.classList.remove('active')
    }

    const menuTargetList = document.getElementsByClassName('js-talkMenu--' + type)
    for (const iterator of menuTargetList) {
      iterator.classList.add('active')
    }
  })
}

//  ####    #####  ##      #####  ######  #####
//  ##  ##  ##     ##      ##       ##    ##
//  ##  ##  #####  ##      #####    ##    #####
//  ##  ##  ##     ##      ##       ##    ##
//  ####    #####  ######  #####    ##    #####
if (document.getElementsByClassName('js-chatDelete')[0]) {
  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (!e.target.classList.contains('js-chatDelete')) {
      return
    }

    const talkID = e.target.dataset.talkId

    document.getElementById('dmTalk-' + talkID).classList.add('removed')

    document.getElementById('dmTalk-text-' + talkID).innerHTML = 'このメッセージは削除されました。'
  })
}
